import { NavLink } from "react-router-dom"
import "./Navbar.scss"

const Navbar = () => {
 
  return (
    <div className="custom-navbar">
      <div className="logo-container">
        <NavLink to="/" className="">
          {/* <img className="logo-image"
            src="#" alt="logo" /> */}
        </NavLink>

      </div>
      <div className="user-profile-container">
        <div className="user-profile">
          <span>
            کاربر فرش
          </span>
          <span>
            - - -
          </span>
        </div>
        <NavLink to="/user/profile" className="">
          {/* <img src="#"
            className="user-profile-image" alt="user-proffile"
          /> */}
        </NavLink>
      </div>
      <div className="hamburger-menu-placeholder"></div>
    </div>
  )
}

export default Navbar